/* Tropical Journal — filtro per tag e "mostra altri" su mobile (sections/tc-blog.liquid).
   Stessa logica della vecchia home del blog: filtro per tag (corrispondenza sul testo dei tag), su mobile senza filtro
   si mostrano 10 articoli alla volta, su desktop tutti. */
(function () {
  "use strict";
  var root = document.querySelector("[data-tc-blog]");
  if (!root) return;

  var grid = document.getElementById("tc-blog-grid");
  var chips = Array.prototype.slice.call(root.querySelectorAll(".tc-blog__chip[data-tag]"));
  var empty = document.getElementById("tc-blog-empty");
  var emptyReset = document.getElementById("tc-blog-reset");
  var moreWrap = document.getElementById("tc-blog-more");
  var moreBtn = document.getElementById("tc-blog-more-btn");
  var cards = Array.prototype.slice.call(grid.querySelectorAll(".tc-blog__card"));

  var STEP = 10;
  var activeTag = "";
  var limit = 10;
  var mq = window.matchMedia("(max-width: 720px)");

  function render() {
    var paginate = mq.matches && !activeTag;
    var max = paginate ? limit : Infinity;
    var visible = 0, shown = 0;
    var needle = activeTag.toLowerCase();

    cards.forEach(function (card) {
      var tags = (card.getAttribute("data-tags") || "").toLowerCase();
      var match = !needle || tags.indexOf(needle) !== -1;
      if (match) {
        visible++;
        var allowed = shown < max;
        card.hidden = !allowed;
        if (allowed) shown++;
      } else {
        card.hidden = true;
      }
    });

    empty.hidden = shown > 0;
    moreWrap.hidden = !(paginate && visible > shown);
    chips.forEach(function (c) {
      var on = (c.getAttribute("data-tag") || "") === activeTag;
      c.classList.toggle("is-active", on);
      c.setAttribute("aria-pressed", on ? "true" : "false");
    });
    root.classList.toggle("is-filtered", !!activeTag);
  }

  function setTag(tag, scroll) {
    activeTag = tag || "";
    limit = STEP;
    render();
    if (scroll) {
      var top = grid.getBoundingClientRect().top + window.pageYOffset - 130;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    }
  }

  chips.forEach(function (chip) {
    chip.addEventListener("click", function () {
      var tag = chip.getAttribute("data-tag") || "";
      setTag(tag === activeTag ? "" : tag, !!tag && tag !== activeTag);
    });
  });
  emptyReset.addEventListener("click", function () { setTag("", false); });
  moreBtn.addEventListener("click", function () { limit += STEP; render(); });
  (mq.addEventListener ? mq.addEventListener.bind(mq, "change") : mq.addListener.bind(mq))(render);

  render();
})();
